<template>
  <div class="page-joinUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_banner.jpg">
    </div>
    <!--大家庭-->
    <Family v-show="tab=='0'"></Family>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>


<script>
import Header from "@/components/header/Header"; //悬浮头部
import Family from "@/pages/kindergarten/family"; //大家庭
import Footer from "@/components/footer/footer"; //底部模块

export default {
  data() {
    return {
      //    tab: this.$route.query.id,
      tab: ""
    };
  },
  components: {
    Header,
    Family,
    "v-footer": Footer
  },
  mounted() {
    //this.$nextTick(() => {
    this.getTab();
    //})
  },
  beforeRouteUpdate() {},
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/index") > -1) {
        this.getTab();
      }
    }
  },
  methods: {
    getTab() {
      let route = this.$route.path;
      if (route.indexOf("/index") > -1) {
        this.tab = "0";
      }
    },
    showChange(val) {
      this.tab = val;
      switch (val) {
        case "0":
          this.$router.push({ name: "index" });
          break;
        default:
          break;
      }
    }
  }
};
</script>


<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-joinUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        /* width:228px;
        height: 68px;*/
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: auto;
            height: 68px;
            padding: 0px 54px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
}
@media (max-width: 767px) {
  .page-joinUs {
    .banner {
      padding-top: 45px;
      .content {
        width: 100%!important;
        position: absolute;
        left: 0!important;
        margin-left: 0!important;
        bottom: 0;
        height: 35px!important;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px!important;
            }
            p {
              width: auto;
              padding: 0 24px!important;
              height: 35px!important;
              font-size: 14px!important;
              line-height: 35px!important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/kindergarten/index.vue